/* Kubota Related Products — slider pagination wiring.
   Custom element binds the CSS scroll-snap strip to the dot row:
   - clicks on dots scroll the corresponding cell into view
   - active dot mirrors the cell currently snapped (intersection observer)
   Pure CSS handles the slider behavior; this JS only syncs the dots.

   Wrapped in an IIFE so the class is function-scoped: this asset is included
   once per consuming section, so a page with multiple instances (e.g. the
   Collection Products Preview ×4 on /collections) loads the script multiple
   times. A bare top-level `class` would throw "Identifier already declared"
   on the 2nd+ load; the IIFE + define-guard makes re-execution a harmless no-op. */

(function () {
  if (customElements.get('kubota-related-products')) return;

  class KubotaRelatedProducts extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._onDotClick = this._onDotClick.bind(this);
  }

  connectedCallback() {
    this.strip = this.querySelector('.kubota-related-products__strip');
    this.cells = Array.from(this.querySelectorAll('.kubota-related-products__cell'));
    this.dots = Array.from(this.querySelectorAll('.kubota-related-products__dot'));

    if (!this.strip || this.cells.length < 2 || this.dots.length === 0) return;

    this.dots.forEach((dot) => dot.addEventListener('click', this._onDotClick));

    this._observer = new IntersectionObserver(
      (entries) => this._handleIntersect(entries),
      {
        root: this.strip,
        threshold: 0.6,
      }
    );
    this.cells.forEach((cell) => this._observer.observe(cell));
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
    this.dots.forEach((dot) => dot.removeEventListener('click', this._onDotClick));
  }

  _onDotClick(event) {
    const target = event.currentTarget;
    const index = parseInt(target.dataset.slideTarget, 10);
    if (Number.isNaN(index) || !this.cells[index]) return;
    this.cells[index].scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest',
    });
  }

  _handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const cellIndex = this.cells.indexOf(entry.target);
      if (cellIndex < 0) return;
      this._setActive(cellIndex);
    });
  }

  _setActive(index) {
    this.dots.forEach((dot, i) => {
      const active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }
}

  customElements.define('kubota-related-products', KubotaRelatedProducts);
})();
